// import React from 'react';
// import { motion } from 'framer-motion';

// const services = [
//   {
//     title: 'Start My Business',
//     description:
//       'In today’s dynamic global market, entrepreneurship is key. We turn your innovative business ideas into reality with expert guidance and support from start to finish.',
//   },
//   {
//     title: 'Business and Tax Registration',
//     description:
//       'Ready to launch your new venture? We simplify the registration process, managing all the necessary business and tax documentation to get you up and running smoothly.',
//   },
//   {
//     title: 'VCFO Services',
//     description:
//       'Elevate your business with our Virtual CFO services. We provide strategic financial planning, insightful analysis, and expert management to drive your growth and success.',
//   },
//   {
//     title: 'Income Tax',
//     description:
//       'Efficiently handle your Income Tax Returns with our expert services. We cater to individuals and corporate employees, ensuring compliance and seamless communication with tax authorities.',
//   },
//   {
//     title: 'Goods and Service tax',
//     description:
//       'Master the complexities of GST with our expert guidance. We help you navigate this comprehensive tax reform, ensuring your business remains compliant and efficient.',
//   },
//   {
//     title: 'Auditing and Attestation',
//     description:
//       'Stay ahead of evolving regulations with our comprehensive auditing and attestation services. We ensure your business meets the highest standards of legal and financial compliance.',
//   },
//   {
//     title: 'Litigations & Appeals',
//     description:
//       'Navigate tax disputes and corporate litigation with confidence. Our team offers expert representation and support through all stages of legal assessments and appeals.',
//   },
//   {
//     title: 'RERA (Real Estate Regulation Act)',
//     description:
//       'Ensure your real estate transactions are compliant with RERA regulations. We provide expert guidance on the Real Estate (Regulation and Development) Act.',
//   },
//   {
//     title: 'Transfer Pricing',
//     description:
//       'Maintain transparency and fairness in related party transactions with our transfer pricing services. We ensure compliance with international standards and regulations.',
//   },
// ];

// const WhatWeDo = () => {
//   return (
//     <div style={{ padding: '60px 20px', backgroundColor: '#fff', maxWidth: '1200px', margin: '0 auto' }}>
//       <h2 style={{ fontSize: '36px', fontWeight: '800', textAlign: 'center', marginBottom: '10px' }}>
//         <span style={{ color: '#5DA840' }}>What </span>
//         <span style={{ color: '#5DA840' }}>We Do</span>
//       </h2>

//       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '40px' }}>
//         <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
//         <div
//           style={{
//             width: '10px',
//             height: '10px',
//             borderRadius: '50%',
//             backgroundColor: 'white',
//             border: '2px solid #023E62',
//             margin: '0 10px',
//           }}
//         />
//         <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
//       </div>

//       <div
//         style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
//           gap: '30px',
//         }}
//       >
//         {services.map((service, index) => (
//           <motion.div
//             key={index}
//             initial={{ opacity: 0, y: -50 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6, delay: index * 0.1 }}
//             style={{
//               background: '#fff',
//               padding: '24px',
//               borderRadius: '10px',
//               boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',
//               display: 'flex',
//               gap: '16px',
//               alignItems: 'flex-start',
//             }}
//           >
//             <div
//               style={{
//                 minWidth: '20px',
//                 height: '20px',
//                 borderRadius: '50%',
//                 backgroundColor: '#5DA840',
//               }}
//             />
//             <div>
//               <h3 style={{ margin: 0,color:'#333', fontSize: '16px', fontWeight: 700 }}>{service.title}</h3>
//               <p style={{ marginTop: '6px', fontSize: '14px', color: '#333', lineHeight: '1.6' }}>
//                 {service.description}
//               </p>
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default WhatWeDo;












import React from 'react';
import { motion } from 'framer-motion';

const services = [
  {
    title: 'Start My Business',
    description:
      'In today’s dynamic global market, entrepreneurship is key. We turn your innovative business ideas into reality with expert guidance and support from start to finish.',
  },
  {
    title: 'Business and Tax Registration',
    description:
      'Ready to launch your new venture? We simplify the registration process, managing all the necessary business and tax documentation to get you up and running smoothly.',
  },
  {
    title: 'VCFO Services',
    description:
      'Elevate your business with our Virtual CFO services. We provide strategic financial planning, insightful analysis, and expert management to drive your growth and success.',
  },
  {
    title: 'Income Tax',
    description:
      'Efficiently handle your Income Tax Returns with our expert services. We cater to individuals and corporate employees, ensuring compliance and seamless communication with tax authorities.',
  },
  {
    title: 'Goods and Service tax',
    description:
      'Master the complexities of GST with our expert guidance. We help you navigate this comprehensive tax reform, ensuring your business remains compliant and efficient.',
  },
  {
    title: 'Auditing and Attestation',
    description:
      'Stay ahead of evolving regulations with our comprehensive auditing and attestation services. We ensure your business meets the highest standards of legal and financial compliance.',
  },
  {
    title: 'Litigations & Appeals',
    description:
      'Navigate tax disputes and corporate litigation with confidence. Our team offers expert representation and support through all stages of legal assessments and appeals.',
  },
  {
    title: 'RERA (Real Estate Regulation Act)',
    description:
      'Ensure your real estate transactions are compliant with RERA regulations. We provide expert guidance on the Real Estate (Regulation and Development) Act.',
  },
  {
    title: 'Transfer Pricing',
    description:
      'Maintain transparency and fairness in related party transactions with our transfer pricing services. We ensure compliance with international standards and regulations.',
  },
];

const WhatWeDo = () => {
  return (
    <div style={{ padding: '60px 20px', backgroundColor: '#fff', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ fontSize: '36px', fontWeight: '800', textAlign: 'center', marginBottom: '10px' }}>
        <span style={{ color: '#5DA840' }}>What </span>
        <span style={{ color: '#5DA840' }}>We Do</span>
      </h2>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '40px' }}>
        <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: 'white',
            border: '2px solid #023E62',
            margin: '0 10px',
          }}
        />
        <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
      </div>

      <div
        className="services-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
          gap: '30px',
        }}
      >
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: -50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="service-card"
            style={{
              background: '#fff',
              padding: '24px',
              borderRadius: '10px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',
              display: 'flex',
              gap: '16px',
              alignItems: 'flex-start',
            }}
          >
            <div className="service-dot" />
            <div className="service-content">
              <h3 style={{ margin: 0, color: '#333', fontSize: '16px', fontWeight: 700 }}>{service.title}</h3>
              <p style={{ marginTop: '6px', fontSize: '14px', color: '#333', lineHeight: '1.6' }}>
                {service.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      <style>
        {`
          /* ✅ Mobile adjustments */
          @media (max-width: 768px) {
            .services-grid {
              grid-template-columns: 1fr !important; /* stack vertically */
            }
            .service-card {
              flex-direction: column !important;
              text-align: center !important;
              align-items: center !important;
            }
            .service-dot {
              width: 14px !important;
              height: 14px !important;
              margin-bottom: 10px !important;
              background-color: #5DA840;
              border-radius: 50%;
            }
            .service-content h3 {
              font-size: 15px !important;
            }
            .service-content p {
              font-size: 13px !important;
            }
          }

          /* ✅ Desktop dot style (unchanged) */
          .service-dot {
            min-width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #5DA840;
          }
        `}
      </style>
    </div>
  );
};

export default WhatWeDo;
